<template>
    <div class="health-check-service">
      <!-- <h2 class="page-title">健康检查服务</h2> -->
      
      <!-- 病人信息查询/确认区 -->
      <el-card class="patient-card" shadow="hover">
        <div slot="header" class="card-header">
          <span><i class="el-icon-user"></i> 病人信息</span>
        </div>
        
        <el-form :model="patientForm" ref="patientForm" label-width="100px" :rules="patientRules">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="patientForm.name" placeholder="请输入姓名">
                  <template slot="append">
                    <el-button icon="el-icon-search" @click="searchPatient">确认</el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="patientForm.idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="patientForm.phone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="性别">
                <el-select v-model="patientForm.gender" placeholder="请选择">
                  <el-option label="男" value="男"></el-option>
                  <el-option label="女" value="女"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="年龄">
                <el-input-number v-model="patientForm.age" :min="0" :max="150"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="就诊卡号">
                <el-input v-model="patientForm.cardNo" placeholder="请输入就诊卡号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item>
            <el-button type="primary" @click="confirmPatient" :disabled="!patientInfo.hasData">确认病人信息</el-button>
            <el-button @click="resetPatientForm">重置</el-button>
          </el-form-item>
        </el-form>
        
        <!-- 病人信息展示区 -->
        <div v-if="patientInfo.hasData" class="patient-info">
          <div class="info-title">确认的病人信息</div>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="姓名">{{ patientInfo.name }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{ patientInfo.gender }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{ patientInfo.age }}岁</el-descriptions-item>
            <el-descriptions-item label="身份证号">{{ patientInfo.idCard }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ patientInfo.phone }}</el-descriptions-item>
            <el-descriptions-item label="就诊卡号">{{ patientInfo.cardNo }}</el-descriptions-item>
          </el-descriptions>
          
          <div class="health-records" v-if="patientInfo.hasData">
            <div class="records-title">病史摘要</div>
            <div class="records-content">{{ patientInfo.healthSummary }}</div>
          </div>
        </div>
      </el-card>
  
      <!-- 检查单开具区 -->
      <el-card class="exam-card" shadow="hover" v-if="patientInfo.hasData">
        <div slot="header" class="card-header">
          <span><i class="el-icon-document-add"></i> 检查单开具</span>
        </div>
        
        <el-form :model="examForm" ref="examForm" label-width="100px" :rules="examRules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="检查科室" prop="department">
                <el-select v-model="examForm.department" placeholder="请选择科室" @change="handleDeptChange">
                  <el-option
                    v-for="dept in departments"
                    :key="dept.value"
                    :label="dept.label"
                    :value="dept.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="检查项目" prop="examType">
                <el-select v-model="examForm.examType" placeholder="请选择检查项目" @change="handleExamTypeChange">
                  <el-option
                    v-for="item in examTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="检查费用">
                <el-input v-model="examForm.cost" disabled>
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="紧急程度">
                <el-radio-group v-model="examForm.urgency">
                  <el-radio label="normal">常规</el-radio>
                  <el-radio label="urgent">加急</el-radio>
                  <el-radio label="emergency">急诊</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="临床信息" prop="clinicalInfo">
            <el-input type="textarea" v-model="examForm.clinicalInfo" rows="3" placeholder="请输入临床诊断/目的/可能的疾病"></el-input>
          </el-form-item>
          
          <el-form-item label="注意事项">
            <el-input type="textarea" v-model="examForm.notes" rows="2" placeholder="请输入检查注意事项"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="submitExam">开具检查单</el-button>
            <el-button @click="resetExamForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      
      <!-- 检查单记录 -->
      <el-card class="history-card" shadow="hover">
        <div slot="header" class="card-header">
          <div class="header-left">
            <span><i class="el-icon-document"></i> 检查单记录</span>
            <el-tag type="info" effect="plain" style="margin-left: 10px">今日共开具 {{ examHistory.length }} 张检查单</el-tag>
          </div>
          <el-radio-group v-model="historyFilter" size="small">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="today">今日</el-radio-button>
            <el-radio-button label="week">本周</el-radio-button>
            <el-radio-button label="completed">已完成</el-radio-button>
          </el-radio-group>
        </div>
        
        <el-table :data="filteredExamHistory" style="width: 100%" border stripe>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="expanded-table-form">
                <el-form-item label="临床信息">
                  <span>{{ props.row.clinicalInfo }}</span>
                </el-form-item>
                <el-form-item label="注意事项">
                  <span>{{ props.row.notes || '无' }}</span>
                </el-form-item>
                <el-form-item label="开单医生">
                  <span>{{ props.row.doctor }}</span>
                </el-form-item>
                <el-form-item label="开单时间">
                  <span>{{ props.row.orderTime }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="病人姓名" prop="patientName" width="120"></el-table-column>
          <el-table-column label="性别/年龄" width="100">
            <template slot-scope="scope">
              {{ scope.row.patientGender }} / {{ scope.row.patientAge }}岁
            </template>
          </el-table-column>
          <el-table-column label="检查科室" prop="department" width="120"></el-table-column>
          <el-table-column label="检查项目" prop="examName"></el-table-column>
          <el-table-column label="费用(元)" prop="cost" width="100"></el-table-column>
          <el-table-column label="紧急程度" width="100">
            <template slot-scope="scope">
              <el-tag :type="getUrgencyType(scope.row.urgency)" size="small">{{ getUrgencyLabel(scope.row.urgency) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small">{{ getStatusLabel(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="printExam(scope.row)">打印</el-button>
              <el-button size="mini" type="success" @click="viewResult(scope.row)" :disabled="scope.row.status !== 'completed'">查看报告</el-button>
              <el-button size="mini" type="danger" @click="cancelExam(scope.row)" :disabled="scope.row.status === 'completed'">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      
      <!-- 检查报告查看对话框 -->
      <el-dialog title="检查报告详情" :visible.sync="reportDialogVisible" width="70%" center>
        <div class="report-header">
          <h3>{{ currentReport.examName }}检查报告</h3>
          <div class="report-info">
            <span>病人：{{ currentReport.patientName }}</span>
            <span>检查日期：{{ currentReport.examDate }}</span>
            <span>报告日期：{{ currentReport.reportDate }}</span>
          </div>
        </div>
        
        <div class="report-content">
          <div class="report-section">
            <h4>检查所见：</h4>
            <p>{{ currentReport.findings }}</p>
          </div>
          
          <div class="report-section">
            <h4>诊断意见：</h4>
            <p>{{ currentReport.diagnosis }}</p>
          </div>
          
          <div class="report-section" v-if="currentReport.images && currentReport.images.length">
            <h4>检查图像：</h4>
            <div class="report-images">
              <img v-for="(img, index) in currentReport.images" 
                  :key="index" 
                  :src="img" 
                  class="report-image"
                  @click="previewImage(img)">
            </div>
          </div>
        </div>
        
        <div class="report-footer">
          <p>检查医生：{{ currentReport.examDoctor }}</p>
          <p>报告医生：{{ currentReport.reportDoctor }}</p>
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="reportDialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="printReport">打印报告</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HealthCheckService',
    data() {
      return {
        // 病人表单
        patientForm: {
          name: '',
          idCard: '',
          phone: '',
          gender: '男',
          age: 30,
          cardNo: ''
        },
        // 病人信息
        patientInfo: {
          hasData: false,
          name: '',
          gender: '',
          age: 0,
          idCard: '',
          phone: '',
          cardNo: '',
          healthSummary: ''
        },
        // 检查单表单
        examForm: {
          department: '',
          examType: '',
          cost: '0',
          urgency: 'normal',
          clinicalInfo: '',
          notes: ''
        },
        // 科室列表
        departments: [
          { value: 'radiology', label: '放射科' },
          { value: 'ultrasound', label: '超声科' },
          { value: 'laboratory', label: '检验科' },
          { value: 'endoscopy', label: '内镜中心' },
          { value: 'cardiology', label: '心电图室' },
          { value: 'neurology', label: '神经电生理科' },
          { value: 'pathology', label: '病理科' }
        ],
        // 检查类型(空数组，会根据科室动态加载)
        examTypes: [],
        // 检查项目映射表
        examTypesMap: {
          radiology: [
            { value: 'ct_chest', label: '胸部CT', cost: 350 },
            { value: 'ct_abdomen', label: '腹部CT', cost: 380 },
            { value: 'ct_head', label: '头颅CT', cost: 320 },
            { value: 'xray_chest', label: '胸部X光', cost: 120 },
            { value: 'xray_joint', label: '关节X光', cost: 100 },
            { value: 'mri_brain', label: '脑部MRI', cost: 980 },
            { value: 'mri_spine', label: '脊柱MRI', cost: 1200 }
          ],
          ultrasound: [
            { value: 'us_abdomen', label: '腹部B超', cost: 180 },
            { value: 'us_cardiac', label: '心脏彩超', cost: 350 },
            { value: 'us_carotid', label: '颈动脉B超', cost: 220 },
            { value: 'us_thyroid', label: '甲状腺B超', cost: 160 },
            { value: 'us_breast', label: '乳腺B超', cost: 190 }
          ],
          laboratory: [
            { value: 'blood_routine', label: '血常规', cost: 50 },
            { value: 'urine_routine', label: '尿常规', cost: 40 },
            { value: 'liver_function', label: '肝功能', cost: 120 },
            { value: 'kidney_function', label: '肾功能', cost: 110 },
            { value: 'blood_lipids', label: '血脂', cost: 80 },
            { value: 'blood_glucose', label: '血糖', cost: 35 }
          ],
          endoscopy: [
            { value: 'gastroscopy', label: '胃镜', cost: 350 },
            { value: 'colonoscopy', label: '肠镜', cost: 450 },
            { value: 'bronchoscopy', label: '支气管镜', cost: 520 }
          ],
          cardiology: [
            { value: 'ecg', label: '心电图', cost: 60 },
            { value: 'holter', label: '动态心电图', cost: 280 },
            { value: 'exercise_ecg', label: '运动负荷心电图', cost: 320 }
          ],
          neurology: [
            { value: 'eeg', label: '脑电图', cost: 220 },
            { value: 'emg', label: '肌电图', cost: 280 },
            { value: 'evoked_potential', label: '诱发电位', cost: 260 }
          ],
          pathology: [
            { value: 'biopsy', label: '活检', cost: 650 },
            { value: 'cytology', label: '细胞学检查', cost: 320 },
            { value: 'frozen_section', label: '冰冻切片', cost: 720 }
          ]
        },
        // 检查单记录
        examHistory: [],
        // 历史记录过滤
        historyFilter: 'today',
        // 表单验证规则
        patientRules: {
          name: [{ required: true, message: '请输入病人姓名', trigger: 'blur' }]
        },
        examRules: {
          department: [{ required: true, message: '请选择检查科室', trigger: 'change' }],
          examType: [{ required: true, message: '请选择检查项目', trigger: 'change' }],
          clinicalInfo: [{ required: true, message: '请输入临床信息', trigger: 'blur' }]
        },
        // 报告对话框
        reportDialogVisible: false,
        // 当前查看的报告
        currentReport: {
          patientName: '',
          examName: '',
          examDate: '',
          reportDate: '',
          findings: '',
          diagnosis: '',
          examDoctor: '',
          reportDoctor: '',
          images: []
        }
      }
    },
    computed: {
      // 根据过滤条件筛选检查历史
      filteredExamHistory() {
        const today = new Date().toISOString().split('T')[0];
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        const weekStart = oneWeekAgo.toISOString().split('T')[0];
        
        return this.examHistory.filter(item => {
          if (this.historyFilter === 'today') {
            return item.orderDate === today;
          } else if (this.historyFilter === 'week') {
            return item.orderDate >= weekStart;
          } else if (this.historyFilter === 'completed') {
            return item.status === 'completed';
          }
          return true; // 'all'
        });
      }
    },
    created() {
      // 模拟加载历史数据
      this.loadMockExamHistory();
    },
    methods: {
      // 搜索病人信息
      searchPatient() {
        if (!this.patientForm.name) {
          this.$message.warning('请输入病人姓名');
          return;
        }
        
        // 模拟查询延迟
        this.$message({
          message: '正在查询病人信息...',
          type: 'info'
        });
        
        setTimeout(() => {
          // 模拟获取病人数据
          const mockPatientData = {
            name: this.patientForm.name,
            gender: this.patientForm.gender,
            age: this.patientForm.age,
            idCard: this.patientForm.idCard || '110101199003072536',
            phone: this.patientForm.phone || '13800138000',
            cardNo: this.patientForm.cardNo || 'P' + Math.floor(100000 + Math.random() * 900000),
            healthSummary: '患者既往有高血压病史5年，控制一般；2型糖尿病3年，规律服用二甲双胍；2022年6月行胆囊结石手术，恢复良好；无药物过敏史；无烟酒嗜好。'
          };
          
          // 填充表单数据
          this.patientForm = { ...mockPatientData };
          
          this.$message({
            message: '已找到病人信息',
            type: 'success'
          });
        }, 500);
      },
      
      // 确认病人信息
      confirmPatient() {
        if (!this.patientForm.name) {
          this.$message.warning('请先填写或查询病人信息');
          return;
        }
        
        this.patientInfo = {
          hasData: true,
          name: this.patientForm.name,
          gender: this.patientForm.gender,
          age: this.patientForm.age,
          idCard: this.patientForm.idCard,
          phone: this.patientForm.phone,
          cardNo: this.patientForm.cardNo,
          healthSummary: '患者既往有高血压病史5年，控制一般；2型糖尿病3年，规律服用二甲双胍；2022年6月行胆囊结石手术，恢复良好；无药物过敏史；无烟酒嗜好。'
        };
        
        this.$message({
          message: '已确认病人信息',
          type: 'success'
        });
      },
      
      // 重置病人表单
      resetPatientForm() {
        this.$refs.patientForm.resetFields();
        this.patientInfo.hasData = false;
      },
      
      // 处理科室变更
      handleDeptChange(val) {
        this.examForm.examType = '';
        this.examForm.cost = '0';
        this.examTypes = this.examTypesMap[val] || [];
      },
      
      // 处理检查项目变更
      handleExamTypeChange(val) {
        if (!val) {
          this.examForm.cost = '0';
          return;
        }
        
        // 查找对应的检查项目获取费用
        const selectedType = this.examTypes.find(item => item.value === val);
        if (selectedType) {
          this.examForm.cost = selectedType.cost.toString();
        }
      },
      
      // 提交检查单
      submitExam() {
        this.$refs.examForm.validate(valid => {
          if (!valid) {
            this.$message.error('请完善检查单信息');
            return;
          }
          
          if (!this.patientInfo.hasData) {
            this.$message.error('请先确认病人信息');
            return;
          }
          
          // 获取检查项目名称
          const examTypeObj = this.examTypes.find(item => item.value === this.examForm.examType);
          const examName = examTypeObj ? examTypeObj.label : '未知检查';
          const deptObj = this.departments.find(item => item.value === this.examForm.department);
          const deptName = deptObj ? deptObj.label : '未知科室';
          
          // 生成检查单号
          const examNo = 'E' + new Date().getTime().toString().slice(-8);
          
          // 获取当前日期时间
          const now = new Date();
          const orderDate = now.toISOString().split('T')[0];
          const orderTime = orderDate + ' ' + now.toTimeString().split(' ')[0];
          
          // 添加到历史记录
          const newExam = {
            id: this.examHistory.length + 1,
            examNo: examNo,
            patientName: this.patientInfo.name,
            patientGender: this.patientInfo.gender,
            patientAge: this.patientInfo.age,
            patientId: this.patientInfo.idCard,
            department: deptName,
            departmentCode: this.examForm.department,
            examType: this.examForm.examType,
            examName: examName,
            cost: this.examForm.cost,
            urgency: this.examForm.urgency,
            clinicalInfo: this.examForm.clinicalInfo,
            notes: this.examForm.notes,
            status: 'waiting', // 等待中
            doctor: '李医生', // 模拟当前医生名称
            orderDate: orderDate,
            orderTime: orderTime,
            completionTime: ''
          };
          
          this.examHistory.unshift(newExam);
          this.$message({
            message: `检查单已开具，单号: ${examNo}`,
            type: 'success'
          });
          
          // 重置表单
          this.$refs.examForm.resetFields();
        });
      },
      
      // 重置检查表单
      resetExamForm() {
        this.$refs.examForm.resetFields();
      },
      
      // 加载模拟历史数据
      loadMockExamHistory() {
        const today = new Date().toISOString().split('T')[0];
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const yesterdayStr = yesterday.toISOString().split('T')[0];
        
        const twoDaysAgo = new Date();
        twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
        const twoDaysAgoStr = twoDaysAgo.toISOString().split('T')[0];
        
        this.examHistory = [
          {
            id: 1,
            examNo: 'E20250408',
            patientName: '许昊然',
            patientGender: '男',
            patientAge: 45,
            patientId: '110101198001010123',
            department: '放射科',
            departmentCode: 'radiology',
            examType: 'ct_chest',
            examName: '胸部CT',
            cost: '350',
            urgency: 'normal',
            clinicalInfo: '患者咳嗽2周，痰中带血丝，发热38.2℃，胸部听诊有湿啰音。为排除肺部感染或肿瘤。',
            notes: '请患者配合深呼吸，保持安静。',
            status: 'completed', // 已完成
            doctor: '王医生',
            orderDate: today,
            orderTime: today + ' 08:30:15',
            completionTime: today + ' 10:15:43'
          },
          {
            id: 2,
            examNo: 'E20250407',
            patientName: '苏雅婷',
            patientGender: '女',
            patientAge: 32,
            patientId: '110101199001010456',
            department: '超声科',
            departmentCode: 'ultrasound',
            examType: 'us_abdomen',
            examName: '腹部B超',
            cost: '180',
            urgency: 'urgent',
            clinicalInfo: '患者右上腹疼痛3天，伴恶心呕吐，疑似胆囊炎或胰腺炎。',
            notes: '请患者空腹。',
            status: 'processing', // 检查中
            doctor: '李医生',
            orderDate: today,
            orderTime: today + ' 09:15:22',
            completionTime: ''
          },
          {
            id: 3,
            examNo: 'E20250406',
            patientName: '林书辰',
            patientGender: '男',
            patientAge: 58,
            patientId: '110101196501010789',
            department: '检验科',
            departmentCode: 'laboratory',
            examType: 'liver_function',
            examName: '肝功能',
            cost: '120',
            urgency: 'emergency',
            clinicalInfo: '患者皮肤巩膜黄染1周，尿色深，食欲减退，疑似肝功能异常。',
            notes: '',
            status: 'waiting', // 等待中
            doctor: '赵医生',
            orderDate: today,
            orderTime: today + ' 11:05:37',
            completionTime: ''
          },
          {
            id: 4,
            examNo: 'E20250405',
            patientName: '程若曦',
            patientGender: '女',
            patientAge: 29,
            patientId: '110101199301010321',
            department: '心电图室',
            departmentCode: 'cardiology',
            examType: 'ecg',
            examName: '心电图',
            cost: '60',
            urgency: 'normal',
            clinicalInfo: '患者近期出现胸闷气短，心悸，可能与工作压力有关，需排除心脏问题。',
            notes: '',
            status: 'completed', // 已完成
            doctor: '张医生',
            orderDate: yesterday.toISOString().split('T')[0],
            orderTime: yesterdayStr + ' 14:30:00',
            completionTime: yesterdayStr + ' 15:10:23'
          },
          {
            id: 5,
            examNo: 'E20250404',
            patientName: '季泽铭',
            patientGender: '男',
            patientAge: 65,
            patientId: '110101195701010987',
            department: '放射科',
            departmentCode: 'radiology',
            examType: 'mri_brain',
            examName: '脑部MRI',
            cost: '980',
            urgency: 'urgent',
            clinicalInfo: '患者近期出现记忆力减退，言语不清，行走不稳，疑似脑血管意外或脑部肿瘤。',
            notes: '患者有幽闭恐惧症，请做好安抚工作。',
            status: 'cancelled', // 已取消
            doctor: '刘医生',
            orderDate: twoDaysAgoStr,
            orderTime: twoDaysAgoStr + ' 09:45:12',
            completionTime: ''
          }
        ];
      },
      
      // 获取紧急程度标签
      getUrgencyLabel(urgency) {
        const labels = {
          normal: '常规',
          urgent: '加急',
          emergency: '急诊'
        };
        return labels[urgency] || urgency;
      },
      
      // 获取紧急程度类型（用于标签颜色）
      getUrgencyType(urgency) {
        const types = {
          normal: 'info',
          urgent: 'warning',
          emergency: 'danger'
        };
        return types[urgency] || 'info';
      },
      
      // 获取状态标签
      getStatusLabel(status) {
        const labels = {
          waiting: '待检查',
          processing: '检查中',
          completed: '已完成',
          cancelled: '已取消'
        };
        return labels[status] || status;
      },
      
      // 获取状态类型（用于标签颜色）
      getStatusType(status) {
        const types = {
          waiting: 'info',
          processing: 'warning',
          completed: 'success',
          cancelled: 'danger'
        };
        return types[status] || 'info';
      },
      
      // 打印检查单
      printExam(row) {
        this.$message({
          message: `正在打印检查单：${row.examNo}`,
          type: 'success'
        });
      },
      
      // 查看检查报告
      viewResult(row) {
        if (row.status !== 'completed') {
          this.$message.warning('检查尚未完成，暂无报告');
          return;
        }
        
        // 模拟报告数据
        const reportDate = new Date(row.completionTime);
        reportDate.setHours(reportDate.getHours() + 1);
        const reportDateStr = reportDate.toISOString().split('.')[0].replace('T', ' ');
        
        // 根据检查类型生成不同的模拟报告
        let findings = '';
        let diagnosis = '';
        let images = [];
        
        if (row.departmentCode === 'radiology') {
          findings = '胸部CT平扫：两肺野未见明显异常密度影，肺纹理清晰，气管及主支气管通畅，纵隔居中，气管及主支气管通畅，心影大小形态正常，主动脉弓无增宽，两侧胸膜无增厚，双侧胸腔未见明显积液。';
          diagnosis = '两肺野未见明显异常，建议结合临床。';
          images = [
            'https://via.placeholder.com/200x200.png?text=CT+Image+1',
            'https://via.placeholder.com/200x200.png?text=CT+Image+2',
            'https://via.placeholder.com/200x200.png?text=CT+Image+3'
          ];
        } else if (row.departmentCode === 'ultrasound') {
          findings = '肝脏：大小正常，形态规则，包膜光滑，肝内回声均匀。门静脉、肝静脉显影清晰。胆囊：大小正常，壁厚约2mm，囊内未见明显异常回声。胰腺：回声均匀，未见明显异常。脾脏：大小正常，回声均匀。双肾：大小正常，形态规则，皮髓质结构清晰，集合系统未见明显扩张及强回声。';
          diagnosis = '肝、胆、脾、胰、双肾未见明显异常回声。';
          images = [
            'https://via.placeholder.com/200x200.png?text=Ultrasound+1',
            'https://via.placeholder.com/200x200.png?text=Ultrasound+2'
          ];
        } else if (row.departmentCode === 'laboratory') {
          findings = 'ALT: 32 U/L (正常范围: 9-50 U/L)\nAST: 28 U/L (正常范围: 15-40 U/L)\n总胆红素: 15 μmol/L (正常范围: 3.4-20.5 μmol/L)\n直接胆红素: 3.5 μmol/L (正常范围: 0-6.8 μmol/L)\n总蛋白: 75 g/L (正常范围: 65-85 g/L)\n白蛋白: 45 g/L (正常范围: 40-55 g/L)';
          diagnosis = '肝功能各项指标均在正常范围内。';
          images = [];
        } else {
          findings = '检查所见正常，未发现明显异常。';
          diagnosis = '未见明显异常，建议结合临床。';
          images = [];
        }
        
        this.currentReport = {
          patientName: row.patientName,
          examName: row.examName,
          examDate: row.completionTime,
          reportDate: reportDateStr,
          findings: findings,
          diagnosis: diagnosis,
          examDoctor: '陈医生',
          reportDoctor: '吴医生',
          images: images
        };
        
        this.reportDialogVisible = true;
      },
      
      // 取消检查
      cancelExam(row) {
        this.$confirm('确定要取消此检查单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const index = this.examHistory.findIndex(item => item.id === row.id);
          if (index !== -1) {
            this.examHistory[index].status = 'cancelled';
            this.$message({
              type: 'success',
              message: '检查单已取消'
            });
          }
        }).catch(() => {});
      },
      
      // 预览图片
      previewImage(url) {
        window.open(url, '_blank');
      },
      
      // 打印报告
      printReport() {
        this.$message({
          message: `正在打印${this.currentReport.examName}报告...`,
          type: 'success'
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .health-check-service {
    padding: 20px;
    background-color: #f5f7fa;
  }
  
  .page-title {
    font-size: 22px;
    color: #303133;
    margin-bottom: 20px;
    font-weight: bold;
  }
  
  .patient-card,
  .exam-card,
  .history-card {
    margin-bottom: 20px;
    border-radius: 4px;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .header-left {
    display: flex;
    align-items: center;
  }
  
  .info-title,
  .records-title {
    font-size: 14px;
    font-weight: bold;
    margin: 15px 0 10px;
    color: #409EFF;
    border-left: 3px solid #409EFF;
    padding-left: 10px;
  }
  
  .patient-info {
    margin-top: 20px;
    border-top: 1px dashed #dcdfe6;
    padding-top: 15px;
  }
  
  .health-records {
    margin-top: 15px;
  }
  
  .records-content {
    padding: 10px;
    background-color: #f8f8f8;
    border-radius: 4px;
    line-height: 1.6;
    color: #606266;
    margin-bottom: 15px;
  }
  
  .expanded-table-form {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 20px;
  }
  
  .expanded-table-form .el-form-item {
    margin-right: 20px;
    margin-bottom: 0;
  }
  
  .report-header {
    text-align: center;
    margin-bottom: 20px;
    border-bottom: 2px solid #409EFF;
    padding-bottom: 15px;
  }
  
  .report-header h3 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  .report-info {
    display: flex;
    justify-content: space-around;
    color: #606266;
    font-size: 14px;
  }
  
  .report-section {
    margin-bottom: 20px;
  }
  
  .report-section h4 {
    font-size: 16px;
    margin-bottom: 8px;
    color: #303133;
  }
  
  .report-section p {
    white-space: pre-line;
    line-height: 1.8;
  }
  
  .report-images {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .report-image {
    width: 200px;
    height: 200px;
    object-fit: cover;
    border: 1px solid #dcdfe6;
    cursor: pointer;
  }
  
  .report-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px dashed #dcdfe6;
    color: #606266;
  }
  </style>